export default [
  {
    inputs: [
      { internalType: "address", name: "msgSender", type: "address" },
      { internalType: "string", name: "role", type: "string" },
    ],
    name: "Unauthorized",
    type: "error",
  },
  {
    anonymous: false,
    inputs: [
      { indexed: false, internalType: "bytes32", name: "code", type: "bytes32" },
      { indexed: false, internalType: "address", name: "newAccount", type: "address" },
    ],
    name: "GovSetCodeOwner",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      { indexed: false, internalType: "address", name: "account", type: "address" },
      { indexed: false, internalType: "bytes32", name: "code", type: "bytes32" },
    ],
    name: "RegisterCode",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      { indexed: false, internalType: "address", name: "account", type: "address" },
      { indexed: false, internalType: "address", name: "newAccount", type: "address" },
      { indexed: false, internalType: "bytes32", name: "code", type: "bytes32" },
    ],
    name: "SetCodeOwner",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      { indexed: false, internalType: "address", name: "prevGov", type: "address" },
      { indexed: false, internalType: "address", name: "nextGov", type: "address" },
    ],
    name: "SetGov",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      { indexed: false, internalType: "address", name: "handler", type: "address" },
      { indexed: false, internalType: "bool", name: "isActive", type: "bool" },
    ],
    name: "SetHandler",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      { indexed: false, internalType: "address", name: "referrer", type: "address" },
      { indexed: false, internalType: "uint256", name: "discountShare", type: "uint256" },
    ],
    name: "SetReferrerDiscountShare",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      { indexed: false, internalType: "address", name: "referrer", type: "address" },
      { indexed: false, internalType: "uint256", name: "tierId", type: "uint256" },
    ],
    name: "SetReferrerTier",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      { indexed: false, internalType: "uint256", name: "tierId", type: "uint256" },
      { indexed: false, internalType: "uint256", name: "totalRebate", type: "uint256" },
      { indexed: false, internalType: "uint256", name: "discountShare", type: "uint256" },
    ],
    name: "SetTier",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      { indexed: false, internalType: "address", name: "account", type: "address" },
      { indexed: false, internalType: "bytes32", name: "code", type: "bytes32" },
    ],
    name: "SetTraderReferralCode",
    type: "event",
  },
  {
    inputs: [],
    name: "BASIS_POINTS",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function",
  },
  { inputs: [], name: "acceptOwnership", outputs: [], stateMutability: "nonpayable", type: "function" },
  {
    inputs: [{ internalType: "bytes32", name: "", type: "bytes32" }],
    name: "codeOwners",
    outputs: [{ internalType: "address", name: "", type: "address" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [{ internalType: "address", name: "_account", type: "address" }],
    name: "getTraderReferralInfo",
    outputs: [
      { internalType: "bytes32", name: "", type: "bytes32" },
      { internalType: "address", name: "", type: "address" },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "gov",
    outputs: [{ internalType: "address", name: "", type: "address" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      { internalType: "bytes32", name: "_code", type: "bytes32" },
      { internalType: "address", name: "_newAccount", type: "address" },
    ],
    name: "govSetCodeOwner",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [{ internalType: "address", name: "", type: "address" }],
    name: "isHandler",
    outputs: [{ internalType: "bool", name: "", type: "bool" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "pendingGov",
    outputs: [{ internalType: "address", name: "", type: "address" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [{ internalType: "address", name: "", type: "address" }],
    name: "referrerDiscountShares",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [{ internalType: "address", name: "", type: "address" }],
    name: "referrerTiers",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [{ internalType: "bytes32", name: "_code", type: "bytes32" }],
    name: "registerCode",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      { internalType: "bytes32", name: "_code", type: "bytes32" },
      { internalType: "address", name: "_newAccount", type: "address" },
    ],
    name: "setCodeOwner",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      { internalType: "address", name: "_handler", type: "address" },
      { internalType: "bool", name: "_isActive", type: "bool" },
    ],
    name: "setHandler",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [{ internalType: "uint256", name: "_discountShare", type: "uint256" }],
    name: "setReferrerDiscountShare",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      { internalType: "address", name: "_referrer", type: "address" },
      { internalType: "uint256", name: "_tierId", type: "uint256" },
    ],
    name: "setReferrerTier",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      { internalType: "uint256", name: "_tierId", type: "uint256" },
      { internalType: "uint256", name: "_totalRebate", type: "uint256" },
      { internalType: "uint256", name: "_discountShare", type: "uint256" },
    ],
    name: "setTier",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      { internalType: "address", name: "_account", type: "address" },
      { internalType: "bytes32", name: "_code", type: "bytes32" },
    ],
    name: "setTraderReferralCode",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [{ internalType: "bytes32", name: "_code", type: "bytes32" }],
    name: "setTraderReferralCodeByUser",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    name: "tiers",
    outputs: [
      { internalType: "uint256", name: "totalRebate", type: "uint256" },
      { internalType: "uint256", name: "discountShare", type: "uint256" },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [{ internalType: "address", name: "", type: "address" }],
    name: "traderReferralCodes",
    outputs: [{ internalType: "bytes32", name: "", type: "bytes32" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [{ internalType: "address", name: "_newGov", type: "address" }],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
] as const;
